import React from 'react';
import ReactDOM from 'react-dom';
import MeteogramSky from './MeteogramSky';

ReactDOM.render(
  <MeteogramSky lat={35.01} lon={135.76} />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js